//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed, defineComponent, useContext, useRoute } from '@nuxtjs/composition-api'
import useUserAuthorization from '~/services/userAuthorization'

const navigation = [
  {
    name: 'gallery',
    link: '/gallery',
    icon: ['fas', 'photo-video']
  },
  {
    name: 'discovery',
    link: '/discovery',
    icon: ['fas', 'compass']
  },
  {
    name: 'vision_groups',
    link: '/vision_groups',
    icon: ['fas', 'folder-open']
  },
  {
    name: 'search',
    link: '/search',
    icon: ['fas', 'search']
  }
]

export default defineComponent({
  setup() {
    const ctx = useContext()
    const route = useRoute()

    const activeNavigationName = computed(() => {
      const baseName = ctx.getRouteBaseName(route.value)
      const routNamePrefix = baseName.includes('-') ? baseName.split('-')[0] : baseName
      const activeNavigation = navigation.find(({ name }) => name === routNamePrefix)
      return (activeNavigation || {}).name
    })

    const userAuthorization = useUserAuthorization(ctx)
    const userVisibleNavigation = computed(() => (
      navigation.filter(({ link }) => userAuthorization.canNavigateTo(link.substring(1, link.length)))
    ))

    return {
      navigation,
      activeNavigationName,
      userVisibleNavigation
    }
  }
})
